import React from 'react';
import { ChevronDown } from 'lucide-react';
import { Button } from './ui/button';

export const Hero = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="relative h-screen w-full overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0">
        <img
          src="https://customer-assets.emergentagent.com/job_property-promo-3/artifacts/t71r6m8i_promotion-immobiliere%201.jpg"
          alt="Modern Architecture"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/60"></div>
      </div>

      {/* Content */}
      <div className="relative h-full flex items-center justify-center">
        <div className="max-w-5xl mx-auto px-6 lg:px-8 text-center">
          <h1 className="text-5xl md:text-7xl lg:text-8xl font-bold text-white mb-6 leading-tight animate-fade-in">
            Créateur d'Espaces
            <span className="block text-[#f5b800] mt-2">d'Exception</span>
          </h1>
          <p className="text-xl md:text-2xl text-white/90 mb-12 max-w-3xl mx-auto leading-relaxed">
            Promoteur immobilier de prestige en Suisse Romande.
            Nous transformons votre vision en réalité architecturale.
            Piloter, Optimiser, Livrer… Chaque mètre carré et une valeur ajoutée!
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <Button
              onClick={() => scrollToSection('properties')}
              size="lg"
              className="bg-[#f5b800] hover:bg-[#d9a400] text-black font-semibold px-8 py-6 text-lg transition-all duration-300 hover:scale-105 shadow-2xl"
            >
              Découvrir nos Biens
            </Button>
            <Button
              onClick={() => scrollToSection('realisations')}
              size="lg"
              variant="outline"
              className="border-2 border-white text-white hover:bg-white hover:text-[#1e5a7a] font-semibold px-8 py-6 text-lg transition-all duration-300 hover:scale-105 shadow-2xl"
            >
              Nos Réalisations
            </Button>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <button
          onClick={() => scrollToSection('realisations')}
          className="flex flex-col items-center text-white hover:text-[#f5b800] transition-colors"
        >
          <span className="text-sm mb-2">Découvrir</span>
          <ChevronDown size={32} />
        </button>
      </div>
    </section>
  );
};